<script>
	import {initializeGsapAnimation} from '../utils.js';
	import {onMount} from 'svelte';

	let divv;
	let main;
	let divv2;
	let divv3;
	let main2;
	let main3;
	onMount(onStart);
	/**
	 */
	function onStart() {
	    initializeGsapAnimation(main, divv, [{x: 600, rotation: 360, duration: 3},
	        {x: 300, rotation: 180, duration: 1}], 3);
	    initializeGsapAnimation(main2, divv2, [{x: 300, rotation: 360, duration: 3},
	        {x: 600, rotation: 180, duration: 1}], 3);
	    initializeGsapAnimation(main3, divv3, [{x: 400, rotation: 360, duration: 3},
	        {x: 100, rotation: 180, duration: 1}], 3);
	}
	
	// export let view_port_height, scroll_y;
	// let distance_from_top, distance_from_bottom;

	// // we will use distance from top and bottom
	// $: if (divv && scroll_y && view_port_height) {
	// distance_from_top = divv.offsetTop - scroll_y;
	// distance_from_bottom = divv.offsetTop - scroll_y - view_port_height;

	// console.log('------------------------');
	// console.log('offset',divv.offsetTop);
	// console.log('offset',divv.offsetTop);
	// console.log('scroll_y', scroll_y);
	// console.log('view_port_height', view_port_height);
	// console.log('distance_from_top', distance_from_top);
	// console.log('distance_from_bottom', distance_from_bottom);
	// }
</script>
<div class="supermain">
	<div class="main" bind:this={main}>
		<div class="box" bind:this={divv}></div>
	</div>
	<div class="main2" bind:this={main2}>
		<div class="box" bind:this={divv2}></div>
	</div>
	<div class="main3" bind:this={main3}>
		<div class="box" bind:this={divv3}></div>
	</div>
</div>

<style>
	.box {
		height: 20vh;
		width: 20vw;
		background-color: red;
		position: absolute;
		top: 50vh;
	}
	.main {
		position: absolute;
		top: 100vh;
		height: 100vh;
		width: 100vw;
		background-color: blue;
	}
	.main2 {
		position: absolute;
		top: 200vh;
		height: 100vh;
		width: 100vw;
		background-color: yellowgreen;
	}
	.main3 {
		position: absolute;
		top: 300vh;
		height: 100vh;
		width: 100vw;
		background-color: orangered;
	}

</style>